import {
  ExclamationCircleOutlined,
  FormOutlined,
  TableOutlined
} from '@ant-design/icons';
import { Col, Row, Spin, Tabs, Tag } from 'antd';
import React, { useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDirtyProducts
} from '../../productmanagement/slices/productsSlice';
import { removeFolder } from '../slices/productImagesSlice';
import { removeProduct } from '../slices/tabProductsSlice';
import { getActiveTab, removeTab, selectAll, setActiveTab, TAB_KEY_GRID, createTab,getTabKey } from '../slices/tabsSlice';
import env from './../../../../../common/config/env';
import AddUpdateProductFormContainer from './addUpdateProductFormContainer/AddUpdateProductFormContainer';
import ButtonContainer from './ButtonContainer';
import GridContainer from './GridContainer';
const getGrid = () => {
  return (
    <Row gutter={[16, 8]}>
      <Col span={24} style={{ height: '68vh' }}>
        <GridContainer />
      </Col>
    </Row>
  );
};
const initialItems = [
  {
    label: (
      <span>
        <TableOutlined />
        Products
      </span>
    ),
    children: getGrid(),
    key: 'tab.key.grid',
    closable: false,
  },
];

function ProductsContainer() {

  const activeTabKey = useSelector(getActiveTab);
  const gridDirtyProducts = useSelector(getDirtyProducts);
  const tabs = useSelector(selectAll);
  const dispatch = useDispatch();
  const newTabIndex = useRef(0);
  const onChange = (key) => {
    dispatch(setActiveTab({key}));
  };
  const remove = (key) => {
    dispatch(removeTab(key));
    dispatch(setActiveTab({key:TAB_KEY_GRID}));
    const product_sku = key.substring(key.lastIndexOf('.')+1);
    dispatch(removeFolder(product_sku));
    dispatch(removeProduct(product_sku));
  };
  const onEdit = (targetKey, action) => {
    if (action !== 'add') {
      remove(targetKey);
    }
  };

  const getItems = () => {
    const items=[...initialItems];
    if (tabs && tabs.length > 0) {
      tabs.forEach((t) => {
         items.push({
          label: (
            <span>
              <FormOutlined />
              {t.childId}
            </span>
          ),
          children: (
            <Spin
              spinning={false}
              key={t.key + '.spinner'}
            >
                <AddUpdateProductFormContainer productId={t.childId} type={t.type} /> 
            </Spin>
          ),
          key: t.key,
          closable: true,
        });
      });
    }
    return items;
  };
const items = useMemo(()=>getItems(),[tabs]);
  return (
    <Row gutter={[16, 16]}>
      <Col span={20}>
        <ButtonContainer />
      </Col>
      <Col span={4}>
        {gridDirtyProducts.length > 0 && (
          <Tag color="warning" icon={<ExclamationCircleOutlined />}>
            Grid data not saved!
          </Tag>
        )}
      </Col>
      <Col span={24}>
        <Tabs
          type="editable-card"
          onChange={onChange}
          activeKey={activeTabKey}
          onEdit={onEdit}
          hideAdd={true}
           items={items}
          defaultActiveKey={TAB_KEY_GRID}
        />
         
      </Col>
    </Row>
  );
}

export default ProductsContainer;


